
























































export default {
  name: 'Distribution',
  components: {},
  props: ['data'],
  computed: {
    distributionMethod() {
      if (this.data.investment.investmentOptions !== null) {
        return this.data.investment.investmentOptions[0].distributionMethod;
      }
      return null;
    },
  },
  methods: {},
};
